import { Check, X, UserCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { api, errMsg } from "@/lib/api";
import { Avatar } from "@/components/PersonCard";
import { toast } from "sonner";

export const ClaimCard = ({ c, user, onAction }) => {
  const act = async (kind) => {
    try {
      const { data } = await api.post(`/claims/${c.claim_id}/${kind}`);
      toast.success(kind === "reject" ? "Claim rejected" : data.status === "approved" ? "Profile linked" : "Approval recorded");
      onAction();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const canApprove = user.can_vote && !c.i_approved && !c.mine;
  return (
    <div className="rounded-3xl border border-[#E5DEC9] bg-white p-6 flex flex-col md:flex-row gap-5 md:items-center" data-testid={`claim-card-${c.claim_id}`}>
      <Avatar p={{ name: c.person_name, photo_url: c.photo_url, gender: c.gender }} size="w-14 h-14 text-lg shrink-0" />
      <div className="flex-1 min-w-0 space-y-1">
        <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#D96B43] flex items-center gap-1"><UserCheck className="w-3 h-3" />Profile claim</p>
        <p className="font-serif text-xl font-semibold"><b>{c.user_name}</b> says they are {c.person_name}</p>
        {c.user_email && <p className="text-xs text-[#7E8E85]">{c.user_email}</p>}
      </div>
      <div className="md:w-56 space-y-2">
        <p className="text-sm font-medium" data-testid={`claim-count-${c.claim_id}`}>{c.approvals}/{c.needed} approvals</p>
        <Progress value={(c.approvals / c.needed) * 100} className="h-2" />
        <div className="flex gap-2 pt-1">
          {canApprove && <Button size="sm" onClick={() => act("approve")} className="rounded-full bg-[#1E3A2B] hover:bg-[#162C20]" data-testid={`claim-approve-btn-${c.claim_id}`}><Check className="w-4 h-4 mr-1" />{user.is_admin ? "Approve now" : "Approve"}</Button>}
          {c.i_approved && <span className="text-xs text-[#2E7D32] self-center">You approved</span>}
          {user.is_admin && <Button size="sm" variant="outline" onClick={() => act("reject")} className="rounded-full text-[#C62828]" data-testid={`claim-reject-btn-${c.claim_id}`}><X className="w-4 h-4 mr-1" />Reject</Button>}
        </div>
      </div>
    </div>
  );
};
